<div class="card mb-3">
  <nexus-card-header [card_title]="card_title"></nexus-card-header>
  <ng-content></ng-content>
</div>